import React from "react";
import { motion } from "framer-motion";

function AboutSection({ title, paragraph1, paragraph2, image }) {
  return (
    <motion.section
      className="p-8"
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8, ease: "easeInOut" }}
    >
      <div className="flex flex-col md:flex-row items-center justify-between md:p-10 p-4">
        {/* Text Content */}
        <motion.div
          className="md:w-1/2 text-center md:text-left"
          initial={{ x: -50, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: "easeInOut", delay: 0.2 }}
        >
          <h1 className="text-4xl font-bold text-primary mb-4 uppercase">{title}</h1>
          <p className="text-justify leading-relaxed text-lg">
            {paragraph1}
            <br />
            <br />
            {paragraph2}
          </p>
        </motion.div>

        {/* Image Content */}
        <motion.div
          className="md:w-1/2"
          initial={{ x: 50, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: "easeInOut", delay: 0.4 }}
        >
          <div className="rounded-lg h-auto w-full flex items-center justify-center">
            <img
              src={image}
              alt="About Us"
              className="w-3/4 h-full object-cover"
            />
          </div>
        </motion.div>
      </div>
    </motion.section>
  );
}

export default AboutSection;
